import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZDiscountCodeInfo } from './models';

const c = initContract();
export const authDiscountContract = c.router(
  {
    getSubscriberPartnerDiscountCode: {
      method: 'GET',
      path: '/get-subscriber-partner-discount-code/:partner_code',
      responses: {
        200: z.object({
          accessGranted: z.boolean(),
          codeInfo: ZDiscountCodeInfo.optional(),
        }),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
